import { render } from "./UserDetail.vue?vue&type=template&id=361b20af&ts=true"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__